import { useClient } from "@/composables/useClient";
import { deserializeCbiDto, serializeCbiDto, encodeRequestParam } from "../serialization/CbiDateCodec";
import type { OptOutApi } from "../../api/OptOutApi";
import type { OptOutGroupStatus } from "../../generated/dto/OptOutGroupStatus";
import type { OptOutSetMemberOptOutRequest } from "../../generated/dto/OptOutSetMemberOptOutRequest";
import type { OptOutStatus } from "../../generated/dto/OptOutStatus";
import type { OptOutUpdateOptOutTokenRequest } from "../../generated/dto/OptOutUpdateOptOutTokenRequest";

export class OptOutApiClient implements OptOutApi {
  constructor(private readonly client = useClient()) {}

  async memberOptOutStatusMember(): Promise<OptOutStatus> {
    const { data } = await this.client.post<unknown>(`/optout/member/memberoptoutstatus`);
    return deserializeCbiDto<OptOutStatus>(data, "generated.dto.OptOutStatus");
  }

  async setMemberOptOutMember(request: OptOutSetMemberOptOutRequest): Promise<OptOutStatus> {
    const { data } = await this.client.post<unknown>(`/optout/member/setmemberoptout`, serializeCbiDto(request, "generated.dto.OptOutSetMemberOptOutRequest"));
    return deserializeCbiDto<OptOutStatus>(data, "generated.dto.OptOutStatus");
  }

  async updateOptOutTokenPublic(request: OptOutUpdateOptOutTokenRequest): Promise<OptOutGroupStatus> {
    const { data } = await this.client.post<unknown>(`/optout/public/updateoptouttoken`, serializeCbiDto(request, "generated.dto.OptOutUpdateOptOutTokenRequest"));
    return deserializeCbiDto<OptOutGroupStatus>(data, "generated.dto.OptOutGroupStatus");
  }
}

export const useOptOutApi = (): OptOutApi => new OptOutApiClient();
